/** "Good morning, Ada" by the reader's own clock. */
export function greetingFor(now: Date, name?: string | null): string {
  const hour = now.getHours();
  const part = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  return name === undefined || name === null || name.trim() === "" ? part : `${part}, ${name}`;
}
